module.exports = __webpack_public_path__ + "static/media/intent-website-image.d416abdb.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/onboard/intent-website-image.svg
// module id = 2634
// module chunks = 51